export default {
    getFilter,
    fromHNode
};

function fromHNode() {
    return getFilter();
}

function getFilter() {
    return {};
}
